import {Button, icons} from '@superweb/ui'

type Props = {
  onFullSize: VoidFunction
}

export function FullSizeControl({onFullSize}: Props) {
  return <Button icon={icons.ArrowFullscreen} onPress={onFullSize} shape="circle" size="s" view="floating" />
}
